module.exports = __webpack_public_path__ + "img/p254.e0761edf.png";